import { ChevronRightIcon } from "@heroicons/react/24/outline";
import { Link } from "@inertiajs/react";
import type { AuditIndexItem } from "@/types";
import { auditTimeLabel } from "@/utils/auditTimeLabel";
import { hostFromUrl } from "@/utils/formatters";
import AuditIssueCount from "./AuditIssueCount";
import AuditStatusBadge from "./AuditStatusBadge";
import AuditStatusIcon from "./AuditStatusIcon";
import { auditStatusDescription } from "./auditIndexHelpers";

export default function AuditListRow({ audit }: { audit: AuditIndexItem }) {
  const title = audit.scenario.objective || "Audit";

  return (
    <Link
      href={`/audits/${audit.id}`}
      className="block border-b border-gray-100 transition-colors last:border-b-0 hover:bg-gray-50"
    >
      <div className="p-5">
        <div className="flex flex-col justify-between lg:flex-row lg:items-center">
          <div className="mb-3 flex grow items-start lg:mb-0">
            <AuditStatusIcon audit={audit} />

            <div className="ml-4 min-w-0 grow">
              <div className="flex flex-wrap items-center">
                <span className="mr-2 truncate text-lg font-medium hover:text-primary">{title}</span>
                {audit.status === "completed" && <AuditIssueCount audit={audit} />}
              </div>

              {audit.scenario.start_url && (
                <p className="mt-1 text-sm text-gray-500">
                  {hostFromUrl(audit.scenario.start_url)}
                  <span className="mx-1 hidden sm:inline-block">•</span>
                  <span className="block sm:inline-block">{auditTimeLabel(audit)}</span>
                </p>
              )}

              <div className="mt-2 flex items-center text-xs text-gray-500">
                <span className="font-medium">{auditStatusDescription(audit)}</span>
              </div>
            </div>
          </div>

          <div className="mt-3 flex items-center justify-between lg:mt-0 lg:ml-4 lg:justify-end">
            <div className="lg:mr-6">
              <AuditStatusBadge audit={audit} />
            </div>

            <ChevronRightIcon className="h-5 w-5 text-primary" aria-hidden="true" />
          </div>
        </div>
      </div>
    </Link>
  );
}
